import React from 'react'
import { i18nTranslate, trackGTMEvents, convertToBoolean } from 'src/utils'
import { Button } from 'react-bootstrap'
import { Card, Form, ListGroup, Row, Col } from 'react-bootstrap'
import { Icons } from 'src/views/components'
import {
  catalogDeps,
  productDeps,
  enableSubscriptionMultiVariant,
  enableSameSkuForFlexibleSubscription,
} from 'src/deps'
import {
  checkEnableButton,
  checkCustomerTypeEligibility,
  modifyAndGetAccountType,
  modifyAndGetCustomerType,
  isFeatureEnabled,
} from 'src/utils'
import {
  catalogContainer,
  nuskinSubscriptionContainer,
  subscriptionContainer,
  cartContainer,
  customerContainer,
  accountsContainer,
  addressContainer,
} from 'src/models'
import {
  getImageFromProperty,
  getLocalStorage,
  getSubscriptionActiveTabName,
} from 'src/utils'
import get from 'lodash/get'
import { observable } from 'mobx'
import { minimumSearchCharLength, APPConfig } from 'config/appConfig'
import { observer } from 'mobx-react'
import { IoMdAddCircleOutline as CircleAdd } from 'react-icons/io'
import debounce from 'lodash/debounce'
import { toastState, ImageComponent, DrawerModal } from 'src/views/components'
import { SingleDrawerProduct } from 'src/views/components/FlexibleSubscription/SingleDrawerProduct/SingleDrawerProduct'
import './styles.scss'
import { notAllowDangerousGoodsToCart } from 'src/utils'
import { overlayState } from '../Overlay'

@observer
class SubscriptionInfiniteScrollV2 extends React.Component {
  @observable productSuggestions = []
  @observable isSearchApiInProgress = true
  @observable inputValue = ''
  @observable height = 70
  @observable page = 1
  @observable size = 5
  @observable totalCount = 0
  @observable isActive = false
  @observable isListening = false
  @observable skuIdToBeAddedInSubscription = ''
  @observable showDrawerModal = false
  @observable shippingMethods = {}
  selectedProductDetails = {}
  constructor(props, context) {
    super(props)
  }

  toggleDrawerModal = () => {
    this.showDrawerModal = !this.showDrawerModal
    if (this.showDrawerModal) {
      this.handleShippingMethod()
    }
  }

  getAddressData = async () => {
    let addressData = {}
    const subscriptionGetAddress =
      await subscriptionContainer.getSubscriptionShippingAddress(
        customerContainer.userId
      )
    if (subscriptionGetAddress) {
      addressData = subscriptionGetAddress
    } else {
      const allAddressData = addressContainer?.addressData
      // Find default address or first address
      const selectedAddress =
        allAddressData?.find(address => convertToBoolean(address?.isDefault)) ||
        allAddressData?.[0]
      if (selectedAddress) {
        addressData = {
          addressLine1: selectedAddress?.addressLine1 || '',
          addressLine2: selectedAddress?.addressLine2 || '',
          addressVersion: selectedAddress?.addressVersion || 0,
          canReceiveSMS: selectedAddress?.canReceiveSMS || false,
          city: selectedAddress?.city || '',
          country: selectedAddress?.country || '',
          county: selectedAddress?.county || '',
          email: selectedAddress?.email || '',
          firstName: selectedAddress?.firstName || '',
          lastName: selectedAddress?.lastName || '',
          phone: selectedAddress?.phone || '',
          state: selectedAddress?.state || '',
          zip: selectedAddress?.zip || '',
        }
      }
    }
    return addressData
  }

  handleShippingMethod = async (prdQty, deliveryType = 'PHYSICAL') => {
    overlayState.showLoader()
    const storeId = getLocalStorage('storeId')
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const { address = {} } = data?.subscriptionData || {}
    const cartValue = this.selectedProductDetails?.transactionPrice?.price
    let addressData = {}
    if (isFromMultipleSubscriptions) {
      addressData = address
    } else {
      addressData = await this.getAddressData()
    }
    let shippingData = {
      cartValue: cartValue,
      deliveryAddress: addressData,
      deliveryType: deliveryType,
    }
    // Refactored to avoid repeated code for itemDetails construction
    let itemDetails = []
    const productType = this.selectedProductDetails.type?.toLowerCase?.() || ''
    if (productType === 'kit') {
      this.selectedProductDetails?.skuKit?.forEach(kit => {
        kit.sku?.forEach(skus => {
          skus.skuWeight = {}
          skus.skuDimension = {}
        })
        itemDetails.push({
          shippingClass: 'DEFAULT',
          sku: kit.sku,
          quantity: prdQty || 1,
          itemQuantity: prdQty || 1,
          storeId: storeId,
        })
      })
    } else if (productType === 'bundle') {
      this.selectedProductDetails?.bundleMandatoryProducts?.forEach(bundle => {
        bundle.sku?.forEach(skus => {
          skus.skuWeight = {}
          skus.skuDimension = {}
        })
        itemDetails.push({
          shippingClass: 'DEFAULT',
          sku: bundle.sku,
          quantity: prdQty || 1,
          itemQuantity: prdQty || 1,
          storeId: storeId,
        })
      })
    } else {
      this.selectedProductDetails?.sku?.forEach(skus => {
        skus.skuWeight = {}
        skus.skuDimension = {}
      })
      itemDetails.push({
        shippingClass: 'DEFAULT',
        sku: this.selectedProductDetails.sku,
        quantity: prdQty || 1,
        itemQuantity: prdQty || 1,
        storeId: storeId,
      })
    }
    shippingData = { ...shippingData, itemDetails }
    const response =
      await subscriptionContainer.postShippingMethod(shippingData)
    if (subscriptionContainer.isSuccessResponse(response)) {
      this.shippingMethods = response?.shipping
    }
    overlayState.hideLoader()
  }

  openSingleSubscribeProductModal = async (
    product = {},
    productDetails = {},
    skuId = '',
    isFromDashboard = false
  ) => {
    if (
      ['bundle', 'kit'].indexOf(
        product && product.type ? product.type.toLowerCase() : ''
      ) > -1
    ) {
      const response = await catalogContainer.getProduct({
        productId: product?.identifier,
      })
      const availableChannels =
        response?.product?.[0]?.properties?.availableChannels || ''
      const isSubscriptionChannelAvailable =
        checkEnableButton(availableChannels, 'subscription') || false
      this.selectedProductDetails = {
        ...(response?.product?.[0] || {}),
        ...(response?.product?.[0]?.properties || {}),
        productId: response?.product?.[0]?.identifier || '',
        isBundle: true,
        categoryId: response?.category?.identifier || '',
        isFromDashboard: isFromDashboard,
        isOneTimeProduct: !isSubscriptionChannelAvailable,
      }
    } else {
      const availableChannels =
        productDetails?.properties?.availableChannels || ''
      const isSubscriptionChannelAvailable =
        checkEnableButton(availableChannels, 'subscription') || false
      this.selectedProductDetails = {
        ...(product || {}),
        ...(productDetails?.properties || {}),
        transactionPrice: productDetails?.prices?.[0] || {},
        skuId: skuId || '',
        skuDetails: productDetails || {},
        productDetails,
        isFromDashboard: isFromDashboard,
        isOneTimeProduct: !isSubscriptionChannelAvailable,
      }
    }
    this.toggleDrawerModal()
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const activeTab = getSubscriptionActiveTabName({
      isFromMultipleSubscriptions,
      activeTab: data?.activeTab,
    })
    trackGTMEvents({
      event: 'subscriptionSearchSelected',
      term: this.inputValue,
      name: productDetails?.properties?.name || '',
      id: productDetails?.identifier || '',
      price: productDetails?.prices?.[0]?.price || 0,
      type: activeTab,
    })
  }

  getProductResponse = async () => {
    const searchTerm = this.inputValue.trim()
    const filters = [
      {
        field: 'index_string_productStatus',
        operation: 'NOTIN',
        value: 'bundleOnly,replacement,discontinued',
      },
    ]
    if (
      typeof isFeatureEnabled === 'function' &&
      isFeatureEnabled('disableDSProductsforRCPFC')
    ) {
      filters.push({
        field: 'index_key_importedDevice',
        operation: 'NOTIN',
        value: 'true',
      })
    }
    const filterValue = { filters }
    const response = await catalogContainer.getSearchProducts({
      queryParams: {
        searchTerm,
        page: this.page,
        skipSearchContentful: true,
      },
      size: this.size,
      filterValue,
    })
    return response
  }
  loadMoreData = async () => {
    if (this.inputValue.trim().length >= minimumSearchCharLength) {
      const response = await this.getProductResponse()
      this.productSuggestions = [
        ...this.productSuggestions,
        ...(response?.product || []),
      ]
    }
  }
  handlerScroll = e => {
    if (
      e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <
      1
    ) {
      if (this.totalCount > 5) {
        this.page = this.page + 1
        this.loadMoreData()
      }
    }
  }

  handleSubscriptionAddToBag = (
    product = {},
    skuDetails = {},
    quantity = 1,
    frequencyPeriod = 1,
    frequencyOrder = 'VARIABLE_MULTI_ORDER'
  ) => {
    const skuId = skuDetails?.identifier || ''
    const productId = product?.identifier || ''
    const categoryName = product?.properties?.categoryName || ''
    if (skuId) {
      return [
        {
          skuId: skuId,
          productId: productId,
          quantity: quantity,
          frequencyPeriod: frequencyPeriod,
          frequencyType: 'MONTHS',
          isPVReserved: this.props.isPvAssistPage ? true : false,
          isSubscriptionPreference: true,
          category: categoryName,
          frequencyOrder,
        },
      ]
    }
    return []
  }
  handlePvItemClick = async (product, skuDetails, skuId) => {
    if (
      subscriptionContainer.selectedPvItems &&
      subscriptionContainer.selectedPvItems.length < 20
    ) {
      this.skuIdToBeAddedInSubscription = skuId
      let cartArray = this.handleSubscriptionAddToBag(product, skuDetails)
      let response = await subscriptionContainer.addToSubscription(cartArray)
      if (subscriptionContainer.isSuccessResponse(response)) {
        this.handleClear()
        this.props.handleSubscription()
        this.props.selectedItemSkuId(response)
      } else {
        toastState.setToastMessage(response.message || '')
      }
      this.skuIdToBeAddedInSubscription = ''
    }
  }

  getPdtImage = (product = {}) => {
    if (product?.type == 'kit' || product?.type === 'bundle') {
      return getImageFromProperty(product?.properties)
    }
    const defaultSku = catalogDeps.getDefaultSelectedSku(product)
    return getImageFromProperty(defaultSku?.[0]?.properties)
  }

  renderDropDown = () => {
    // Don't show dropdown if input is empty or below minimum length
    if (this.inputValue.trim().length < minimumSearchCharLength) {
      return null
    }

    const { isFromMultipleSubscriptions = false } = this.props
    let subscriptionsData = {}
    if (isFromMultipleSubscriptions) {
      const { subscriptionData } = this.props?.data
      const { items = [] } = subscriptionData
      subscriptionsData = items
    } else {
      subscriptionsData =
        nuskinSubscriptionContainer?.subscriptionData?.subscriptions
    }
    if (!this.isSearchApiInProgress) {
      const enableSubscriptionVariantSearch = convertToBoolean(
        APPConfig?.getAppConfig()?.enableSubscriptionVariantSearch
      )
      const splittedProducts = enableSubscriptionMultiVariant()
        ? this.productSuggestions
        : enableSubscriptionVariantSearch
          ? catalogDeps.splitSkuBasedProduct(this.productSuggestions)
          : this.productSuggestions

      const filteredProducts =
        splittedProducts?.filter(product => {
          const isBundle = productDeps.isBundleData(product)
          const isDirectSellerProduct =
            APPConfig?.getAppConfig()?.disableDSProductsforRCPFC === 'true' &&
            productDeps.isDirectSellerProduct(product)
          if (isDirectSellerProduct) {
            return false
          }
          const availableChannels = isBundle
            ? product?.properties?.availableChannels || ''
            : product?.sku?.[0]?.properties?.availableChannels || ''
          // const isSubscriptionOrWebAvailable =
          //   checkEnableButton(availableChannels, 'subscription') ||
          //   checkEnableButton(availableChannels, getWebAvailableChannel())
          const isSubscriptionOrWebAvailable = checkEnableButton(
            availableChannels,
            'subscription'
          )
          if (isSubscriptionOrWebAvailable) {
            let accoutTypeResult =
              modifyAndGetAccountType(
                customerContainer?.profileResponse?.accounts?.accountType
              ) || ''
            const customerTypeResult =
              modifyAndGetCustomerType(
                product?.sku?.[0]?.properties?.customerTypes
              ) || ''
            const isCustomerEligible = checkCustomerTypeEligibility(
              customerTypeResult,
              accoutTypeResult
            )
            const isProuctAvailable =
              product?.sku?.[0]?.inventory?.toLowerCase() !== 'unavailable'
            return isCustomerEligible && isProuctAvailable
          } else {
            return false
          }
        }) || []

      if (
        typeof filteredProducts != 'undefined' &&
        filteredProducts.length == 0
      ) {
        if (this.inputValue.length >= minimumSearchCharLength) {
          const searchNoResults = i18nTranslate(
            'subscription.searchNoResults',
            'No Results Found'
          )
          return (
            <div className="dropdown-subscription">
              <div className="subscription-result">
                <Card className="subs-input-card">
                  <Card.Body className="p-2">
                    <Row className="infinite-search-custom-row m-0">
                      <Col className="pl-0">
                        <div className="custom-infinite-scroll">
                          <strong>{searchNoResults}</strong>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            </div>
          )
        }
        return null
      } else {
        const searchCardAdd = i18nTranslate('subscription.searchCardAdd', 'ADD')
        const searchCardAdded = i18nTranslate(
          'subscription.searchCardAdded',
          'ADDED'
        )
        const searchCardOOS = i18nTranslate('subscription.searchCardOOS', 'OOS')
        const searchCardUnavailable = i18nTranslate(
          'subscription.searchCardUnavailable',
          'Unavailable'
        )
        return (
          <div
            className="dropdown-subscription"
            data-testid="qa-subscription-quick-add-suggestion-dropdown"
            id="dropdownsubscriptionId">
            <div
              className="subscription-result"
              id="subscription-result-id"
              onScroll={this.handlerScroll}
              style={{ overflowY: 'auto' }}>
              {typeof filteredProducts != 'undefined' &&
                filteredProducts.length > 0 &&
                filteredProducts.map((product, index) => {
                  if (
                    typeof product.type == 'undefined' ||
                    !['fixedpricebundle', 'collection'].includes(
                      product.type.toLowerCase()
                    )
                  ) {
                    let btnLabel = searchCardAdd
                    const selectedSKU =
                      catalogDeps.getDefaultSelectedSku(product)
                    const productDetails = selectedSKU[0] || product || {}
                    const name =
                      get(productDetails, 'properties.name', '') ||
                      get(product, 'properties.name', '')
                    const imageURL = this.getPdtImage(product)
                    const variant =
                      get(productDetails, 'properties.variant', '') ||
                      get(product, 'properties.variant', '') ||
                      get(product, 'identifier', '')
                    const itemValue = productDetails?.identifier || ''
                    const isStarterKit =
                      productDetails?.properties?.isstarterkit || '' === 'true'
                        ? true
                        : false
                    const inventoryStatus = productDetails?.inventory || ''
                    const availableInStore =
                      productDetails?.properties?.availableinstore || ''
                    const isAvailableInStore = availableInStore === '0'
                    const isInActiveItem =
                      availableInStore === '3' || availableInStore === '5'
                        ? true
                        : false
                    const isOOSItem =
                      inventoryStatus?.toLowerCase() === 'out of stock' || false
                    const dangerousGoods =
                      (productDetails?.skuProperties?.dangerousGoods ===
                        'true' ||
                        productDetails?.properties?.dangerousGoods === 'true' ||
                        product?.properties?.dangerousGoods === 'true') &&
                      notAllowDangerousGoodsToCart()
                    let isItemSubscribed = false
                    if (!this.props.isPvAssistPage) {
                      const totalSubscriptionCount = isFromMultipleSubscriptions
                        ? subscriptionsData.length
                        : cartContainer.subscriptionResponse
                            ?.totalSubscriptionCount || 0
                      if (totalSubscriptionCount) {
                        const isBundle =
                          ['bundle', 'kit'].indexOf(
                            product && product.type
                              ? product.type.toLowerCase()
                              : ''
                          ) > -1
                        let productIds = ''
                        if (isBundle) {
                          productIds =
                            product?.bundlemandatoryproductids ||
                            product?.identifier ||
                            ''
                        } else {
                          productIds = product?.identifier
                        }
                        isItemSubscribed =
                          subscriptionsData &&
                          subscriptionsData.some(item => {
                            let skus = []
                            if (isFromMultipleSubscriptions) {
                              skus = (item?.skus?.length && item?.skus) || []
                            } else {
                              skus =
                                (item?.itemInfo?.length &&
                                  item?.itemInfo?.[0]?.skus) ||
                                []
                            }

                            const searchSkuId =
                              selectedSKU?.[0]?.identifier || ''
                            /*Commented productId check as normal product with multi variant
                               is not allowing different sku of same product to add */
                            //productIds?.indexOf(sku?.productId) > -1
                            return skus.some(sku => {
                              return ['DEFAULT', 'SKUKIT', 'BUNDLE'].includes(
                                sku?.type
                              ) &&
                                (sku?.type?.toLowerCase() === 'bundle' ||
                                sku?.type?.toLowerCase() === 'skukit'
                                  ? productIds?.indexOf(sku?.productId) > -1
                                  : searchSkuId === sku?.id)
                                ? true
                                : false
                            })
                          })
                      }
                    }

                    if (
                      isItemSubscribed &&
                      !enableSameSkuForFlexibleSubscription()
                    ) {
                      btnLabel = searchCardAdded
                    } else if (isInActiveItem) {
                      btnLabel = searchCardOOS
                    } else if (isOOSItem) {
                      btnLabel = searchCardAdd
                    } else if (isStarterKit || isAvailableInStore) {
                      btnLabel = searchCardUnavailable
                    }

                    const skuId =
                      get(productDetails, 'identifier', '') ||
                      get(product, 'identifier', '') ||
                      ''
                    const isBundle = productDeps.isBundleData(product)
                    const isToDisableAddButton =
                      (skuId === this.skuIdToBeAddedInSubscription ||
                        isStarterKit ||
                        isInActiveItem ||
                        dangerousGoods ||
                        isAvailableInStore ||
                        btnLabel === searchCardAdded) &&
                      !isBundle
                    const showSearchSuggestionImage =
                      APPConfig?.getAppConfig()?.showSearchSuggestionImage ===
                      'true'
                    return (
                      <Card
                        className={`subs-input-card ${
                          isToDisableAddButton ? 'disable-add-subs' : ''
                        }`}
                        aria-disabled={isToDisableAddButton}
                        aria-label={name + ' #' + itemValue}
                        key={index}
                        tabIndex={isToDisableAddButton ? -1 : 0}
                        role="button"
                        onClick={() =>
                          !isToDisableAddButton &&
                          this.openSingleSubscribeProductModal(
                            product,
                            productDetails,
                            skuId,
                            true
                          )
                        }
                        onKeyDown={event => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            if (isToDisableAddButton) {
                              return
                            }
                            event.preventDefault()
                            this.openSingleSubscribeProductModal(
                              product,
                              productDetails,
                              skuId,
                              true
                            )
                          }
                        }}>
                        <ListGroup variant="flush">
                          <ListGroup.Item className="p-0" key={index}>
                            <Card.Body className="p-2">
                              <Row
                                className={`infinite-search-custom-row m-0 ${
                                  showSearchSuggestionImage
                                    ? 'with-image'
                                    : 'without-image'
                                }`}>
                                {showSearchSuggestionImage && (
                                  <ImageComponent
                                    testid="qa-product-search-image"
                                    overrideParentClass={true}
                                    customParentClassName="product-search-wrapper mr-2"
                                    className="product-search-image"
                                    src={imageURL || ''}
                                    alt={name}
                                    optimizeImage={true}
                                    height={'50px'}
                                    width={'50px'}
                                  />
                                )}
                                <Col className="pl-0 search-text-section">
                                  <div className="custom-infinite-scroll">
                                    <strong data-testid="qa-subscription-quick-add-suggestion-sku-name">
                                      {name}
                                    </strong>
                                    <p
                                      className="m-0"
                                      data-testid="qa-subscription-quick-add-suggestion-sku-id">
                                      {/* <span>{variant}</span>  CX15-9055-  identifiers should not be shown*/}
                                      #<span>{itemValue}</span>
                                    </p>
                                  </div>
                                </Col>
                                <Col className="pr-0 pl-0">
                                  {searchCardAdded === btnLabel && !isBundle ? (
                                    <Button
                                      className="float-right infinite-search-add-button"
                                      variant="primary"
                                      style={{
                                        backgroundColor: '#89b59b',
                                      }}
                                      disabled={isToDisableAddButton}>
                                      {btnLabel}
                                    </Button>
                                  ) : (
                                    <div
                                      className={`d-flex flex-row-reverse ${
                                        isToDisableAddButton && `disabled`
                                      }`}
                                      data-testid="qa-subscription-quick-add-suggestion-add-button"
                                      // onClick={() =>
                                      //   this.openSingleSubscribeProductModal(
                                      //     product,
                                      //     productDetails,
                                      //     skuId,
                                      //     true
                                      //   )
                                      // }>
                                    >
                                      <CircleAdd className="circle-add-button" />
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              {dangerousGoods && (
                                <span className="text-bundle-danger msg-style">
                                  {i18nTranslate(
                                    'pdp.dangerousGoodsError',
                                    'Dangerous Goods cannot be added to Cart or Subscribed',
                                    {
                                      nameSpace: 'ssr-resource',
                                    }
                                  )}
                                </span>
                              )}
                            </Card.Body>
                          </ListGroup.Item>
                        </ListGroup>
                      </Card>
                    )
                  }
                })}
            </div>
          </div>
        )
      }
    } else {
      return <></>
    }
  }

  handleInputChange = event => {
    this.inputValue = event.target.value
    if (this.inputValue.trim().length >= minimumSearchCharLength) {
      //make the call to api and fetch the response and assign it to the userSuggestion
      this.isSearchApiInProgress = true
      this.debounceQuickAddProduct()
    } else {
      this.productSuggestions = []
      this.page = 1
    }
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const activeTab = getSubscriptionActiveTabName({
      isFromMultipleSubscriptions,
      activeTab: data?.activeTab,
    })
    this.inputValue &&
      this.inputValue?.length >= 5 &&
      trackGTMEvents({
        event: 'subscriptionSearch',
        term: this.inputValue,
        type: activeTab,
      })
  }

  debounceQuickAddProduct = debounce(async () => {
    this.page = 1
    // page resetting is done here when call is made for new search keyword
    const response = await this.getProductResponse()
    this.productSuggestions = response?.product || []
    this.totalCount = response?.pageableInfo?.totalCount || 0
    this.isSearchApiInProgress = false
  }, 700)

  setRef = node => {
    this.searchContainerNode = node
  }
  disableListener = () => {
    if (this.isListening === true) {
      if (typeof window === 'object') {
        window.removeEventListener('click', this.handleOutsideClick)
        this.isListening = false
      }
    }
  }
  handleOutsideClick = event => {
    if (
      this.searchContainerNode &&
      !this.searchContainerNode.contains(event.target)
    ) {
      this.isActive = false
      this.handleClear()
      this.disableListener()
    }
  }
  enableListener = () => {
    if (this.isActive === true && this.isListening === false) {
      if (typeof window === 'object') {
        window.addEventListener('click', this.handleOutsideClick)
        this.isListening = true
      }
    }
  }
  handleBoundaryBlur = () => {
    this.isActive = true
    this.enableListener()
  }
  handleClear = () => {
    this.inputValue = ''
    this.productSuggestions = []
    this.page = 1
  }

  renderPopupData = shippingMethodList => {
    return (
      <SingleDrawerProduct
        product={this.selectedProductDetails}
        shippingMethodList={shippingMethodList}
        term={this.inputValue}
        {...this.props}
        toggleDrawerModal={this.toggleDrawerModal}
        handleShippingMethod={this.handleShippingMethod}
      />
    )
  }
  render() {
    const searchPlaceholder = i18nTranslate(
      'subscription.searchPlaceholder',
      'Product Quick-Add'
    )
    const customWidth = this.props.isPvAssistPage ? 'col-md-9' : 'col-md-6'

    return (
      <>
        <div
          ref={this.setRef}
          className="subs-input-parent d-flex"
          onBlur={this.handleBoundaryBlur}>
          <Icons
            name="header-icons"
            icontype="search"
            width="13px"
            className="enable-search-icon"
            data-testid="qa-search-icon"
            ariaLabel={i18nTranslate('icons.searchicon', 'search icon', {
              nameSpace: 'ssr-resource',
            })}
            alt={i18nTranslate('icons.searchicon', 'search icon', {
              nameSpace: 'ssr-resource',
            })}
          />
          <Form.Control
            id="subscriptionSearchInput"
            type="text"
            className={`search-textBox bg-transparent `}
            data-testid="qa-search-add-button"
            placeholder={searchPlaceholder}
            onClick={async e => {
              nuskinSubscriptionContainer.collectAllSubscriptions()
            }}
            onChange={this.handleInputChange}
            autoComplete="off"
            value={this.inputValue}
            disabled={this.props.isPvAssistPage && !this.props.isPvActive}
            role="searchbox"
            aria-label="subscription search input"
          />
          {this.renderDropDown()}
        </div>
        {this.showDrawerModal && (
          <DrawerModal
            renderView={this.renderPopupData}
            propsValue={this.shippingMethods}
            show={this.showDrawerModal}
            onHide={this.toggleDrawerModal}></DrawerModal>
        )}
      </>
    )
  }
}

export default SubscriptionInfiniteScrollV2
export { SubscriptionInfiniteScrollV2 }
